var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-title"},[_c('div',{staticClass:"category-title__icon",domProps:{"innerHTML":_vm._s(_vm.icon)}}),_c('div',{staticClass:"category-title__caption"},[_vm._v(_vm._s(_vm.category.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }